<script>
  import MenuHeading from "./../../shared/MenuHeading.svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import { onMount, createEventDispatcher } from "svelte";
  import r from "react-image-file-resizer";
  import Select from "svelte-select";
  import loadData from "../../utils/loadData";

  const dispatch = createEventDispatcher();

  export let orderNumber;
  export let orderID;

  let fPhoto = null;
  let fGraphic = null;
  let resize = r.imageFileResizer;
  let resizeImage, resizeImages;
  let errCount = 0;

  let class_ = null;

  let uploading = false;

  onMount(async () => {
    console.log(orderID);

    resizeImage = (file) => {
      return new Promise((resolve, reject) => {
        resize(file, 500, 500, "JPEG", 50, 0, (uri) => resolve(uri), "blob");
      });
    };

    resizeImages = async (files) => {
      let resized = [];
      for (let i = 0; i < files.length; i++)
        resized.push(await resizeImage(files[i]));
      return resized;
    };
  });

  let genSKU = (name, size = 5) => {
    if (name) {
      let temp = name
        .replaceAll("  ", " ")
        .split(" ")
        .slice(0, size)
        .map((words) => words.slice(0, 3))
        .join("-")
        .replaceAll("--", "-")
        .replaceAll("--", "-")
        .toUpperCase();
      return temp;
    } else return "";
  };

  let genStyleSKU = (styleName, styleSize) => {
    return `${genSKU(styleName, 2)}-${genSKU(styleSize, 5)}`;
  };

  let inventoryLevel = 1;
  let name = null;
  let price = 0;
  let SKU = null;

  const handleClear = () => {
    name = null;
    price = 0;
    inventoryLevel = null;
    SKU = null;
    class_ = null;
  };

  const handleSubmit = async (e) => {
    if (
      $config?.fstyles?.find(({ label }) => $config.f._has_(label, `${name}`))
    ) {
      alert("⚠ This Finished Product already exists");
      return;
    }

    if (name) SKU = genSKU(name);
    if (!name) alert("Name Missing");
    if (!class_) alert("Category missing!");
    // else if (!price) alert("Price missing!");
    else if (!SKU) alert("SKU missing!");
    else if (!fPhoto) alert("Photo missing!");
    // else if (!fGraphic) alert("Graphic missing!");
    else {
      uploading = true;

      const formData = new FormData();

      orderNumber && formData.append("orderNumber", orderNumber);
      orderID && formData.append("orderID", orderID);
      name && formData.append("name", name);
      price && formData.append("price", price);
      inventoryLevel && formData.append("inventoryLevel", inventoryLevel || 0);
      SKU && formData.append("SKU", SKU);
      class_ && formData.append("class_", class_.value);

      let resizedImg;

      resizedImg = await resizeImage(fPhoto[0]);
      formData.append("photo", resizedImg);

      if (fGraphic) {
        console.log("There is a graphic");
        resizedImg = await resizeImage(fGraphic[0]);
        formData.append("graphic", resizedImg);
      }

      axios
        .post(
          `${$config.backendURL}/fstyles${fGraphic ? "" : "/no-graphic"}`,
          formData,
          {
            headers: { authorization: ls.get("jwt") },
          }
        )
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Added Successfully`);
          dispatch("productCreated");
          errCount = 0;
          window.location.reload();
          loadData();
          handleClear();
        })
        .catch((err) => {
          uploading = false;
          errCount++;
          if (errCount <= 3) {
            handleSubmit();
            console.log(`Retrying... ${errCount}`);
          } else {
            console.log(`Done Retrying... xxx`);
            console.log(err);
            alert("There was a problem, Refresh the page and retry");
          }
        });
    }
  };
</script>

<form
  on:submit|preventDefault={handleSubmit}
  class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
>
  <div class="col-span-full -mt-10">
    <MenuHeading
      title="Create Product for this Job Card"
      description="Fill out the form below to enter the item details."
    />
  </div>

  <div class="grid grid-cols-2 gap-8">
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Product Name :</div>
      <input
        class="col-span-2 shadow-sm placeholder-gray-300"
        type="text"
        bind:value={name}
        placeholder="Finished Product Name"
      />
    </div>
    <!-- <div class="grid grid-cols-3 gap-2 items-center">
      <div>Price :</div>
      <input
        class="col-span-2 shadow-sm placeholder-gray-300"
        type="number"
        step="any"
        bind:value={price}
        placeholder="Price"
      />
    </div> -->
  </div>

  <div class="grid grid-cols-2 gap-8">
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Photo :</div>
      <label
        for="product-photo"
        class:border-brand={fPhoto}
        class:text-brand={fPhoto}
        class:border-gray-200={!fPhoto}
        class:text-gray-300={!fPhoto}
        class="py-2 px-4 flex items-center justify-start cursor-pointer col-span-2 h-full bg-white rounded-xl border shadow-sm"
      >
        {#if fPhoto}
          <i class="fas fa-check-circle text-brand text-base mr-2" />
          Photo Selected
        {:else}
          <i class="fas fa-camera text-base mr-2" />
          Product's Photo
        {/if}
      </label>
    </div>
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>[Optional] Graphic :</div>
      <label
        for="product-graphic"
        class:border-brand={fGraphic}
        class:text-brand={fGraphic}
        class:border-gray-200={!fGraphic}
        class:text-gray-300={!fGraphic}
        class="py-2 px-4 flex items-center justify-start cursor-pointer col-span-2 h-full bg-white rounded-xl border shadow-sm"
      >
        {#if fGraphic}
          <i class="fas fa-check-circle text-brand text-base mr-2" />
          Graphic Selected
        {:else}
          <i class="fas fa-image text-base mr-2" />
          [OPTIONAL] Product's Graphic
        {/if}
      </label>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-8">
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Choose Category :</div>
      <div class="col-span-2">
        <Select
          items={$config.fStyleC}
          on:select={(e) => (class_ = e.detail)}
        />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity :</div>
      <input
        class="col-span-2 shadow-sm placeholder-gray-300"
        type="number"
        bind:value={inventoryLevel}
        placeholder="Quantity"
      />
    </div>
  </div>

  <div class="hidden">
    <input
      bind:files={fPhoto}
      type="file"
      accept="image/*"
      id="product-photo"
      class="appearance-none"
    />
  </div>

  <div class="hidden">
    <input
      bind:files={fGraphic}
      type="file"
      accept="image/*"
      id="product-graphic"
      class="appearance-none"
    />
  </div>

  {#if uploading}
    <div class="grid grid-cols-1 gap-8">
      <div class="flex items-center justify-center btn btn-primary-outline">
        <Wave size="25" color="rgb(244,162,97)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    </div>
  {:else}
    <!-- else content here -->
    <div class="grid grid-cols-2 gap-8">
      <button class="btn btn-primary-outline" on:click={handleClear}>
        <i class="fas fa-times-circle mr-3" />
        Clear Form
      </button>
      <button class="btn btn-primary" on:click={handleSubmit}>
        <i class="fas fa-check-circle mr-3" />
        Save to Database
      </button>
    </div>
  {/if}
</form>
